@if (night()) {
  <app-night-theme />
}

<tui-loader [showLoader]="(isLoading | async) || false" [overlay]="(isLoading | async) || false">
  <tui-root [attr.tuiTheme]="night() ? 'dark' : null" [attr.data-theme]="dataTheme">
    <router-outlet />
  </tui-root>
</tui-loader>
